import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SignaturePadModule } from '@shared/components/signature-pad';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { UploadFileControl, UploadFileModel } from '@portal/upload-file/data-access';
import { Helper } from '@portal/util';
import { NgIf } from '@angular/common';

@Component({
  selector: 'portal-form-signature-pad',
  standalone: true,
  imports: [MatIconModule, SignaturePadModule, FormsModule, NgIf],
  template: `
    <div class="field-signature-wrapper">
      <canvas
        redSignatureDrawer
        class="size-full"
        [(ngModel)]="base64image"
      ></canvas>

      <button
        type="button"
        class="field-signature-clear"
        (click)="onClear()"
      >
        <mat-icon
          svgIcon="eraser"
          class="icon-size-4"
        ></mat-icon>
      </button>

      <button
        *ngIf="base64image"
        type="button"
        class="field-signature-save"
        (click)="onSave()"
      >
        Save
      </button>
    </div>
  `,
  styles: [':host{display: block}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SignaturePadComponent),
    },
  ],
})
export class SignaturePadComponent implements ControlValueAccessor {
  @Input() fileName?: string;
  protected base64image?: string;
  private signatureFile: UploadFileControl = new Map();

  writeValue(value?: UploadFileControl): void {
    this.signatureFile = value || new Map();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  protected onClear(): void {
    this.base64image = undefined;
    this.signatureFile.clear();
    this.onChange(this.signatureFile);
  }

  protected onSave(): void {
    if (!this.base64image) return;

    const id = Helper.randomId(4);
    const fileName = this.fileName || 'signature.png';
    const file = Helper.createFileFromBase64(this.base64image, fileName);

    this.signatureFile.set(id, UploadFileModel.fromJson({ id, file, fileName }));

    this.onChange(this.signatureFile);
  }

  private onTouched: () => void = () => {};

  private onChange: (newValue?: UploadFileControl) => void = () => {};
}
